export default __webpack_public_path__ + "static/media/sambhav new(3).8ed2b999.png";